// New component created by srini on 02-04-25 for engagement section

import { useState, useCallback, useContext } from "react"
import { Grid, Typography, Button } from "@mui/material"

import { withStyles } from "@material-ui/core/styles"
import { DataGrid } from '@mui/x-data-grid'
import exportFromJSON from 'export-from-json'
import { httpRequest } from "../../../../ui-utils/api"
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig"
import snackError from "../../../../helpers/snackError"

import dayjs from "dayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import styles from './engagementStyles'
import { reducerContext } from "../../../../contextApi's/contextApi's"
import { IconButton } from "@material-ui/core"
import InfoIcon from "@mui/icons-material/Info"

import IncomeForm from "./IncomeForm"

const AgentsList = ({ classes }) => {
    const userId = localStorage.getItem('user_id1')
    const { dispatch } = useContext(reducerContext)

    const [agentsList, setAgentsList] = useState([

    ])
    const [agentIncome, setAgentIncome] = useState({})
    const [showModal, setShowModal] = useState(false)

    const [fdate, setfdate] = useState(null)
    const [tdate, settdate] = useState(null)
    const [error, setError] = useState({ from: "", to: "" })

    const handleFDate = useCallback((newValue) => {
        setfdate(dayjs(newValue).format('YYYY-MM-DD'))
        setError((prev) => ({ ...prev, from: "" }))
    }, [])

    const handleTDate = useCallback((newValue) => {
        settdate(dayjs(newValue).format('YYYY-MM-DD'))
        setError((prev) => ({ ...prev, to: "" }))
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault()

        let newError = { from: "", to: "" }

        if (!fdate) {
            newError.from = "From date is required"
            setError(newError)
            return
        }

        if (!tdate) {
            newError.to = "To date is required"
            setError(newError)
            return
        }
        const franchisee_list = JSON.parse(localStorage.getItem("sipRegData")).franchaise_list || []
        const payload = {
            fdate, tdate,franchisee_list
        }

        try {
            const engagementResult = await httpRequest({
                endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.ref_managementList}`,
                method: "post",
                instance: "instanceOne",
                requestBody: payload
            })

            if (engagementResult.status === 200) {
                setAgentsList(engagementResult.data)
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error in fetching Management List' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error in fetching Management List", engagementResult)
            }
        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error in fetching Management List' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error in fetching Management List", error)
        }
    }

    const handleIncomeApi = async (agentId) => {

        if (!agentId) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Agent Id is require.' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            return
        }

        try {
            const engagementIncome = await httpRequest({
                endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.ref_management_income}`,
                method: "post",
                instance: "instanceOne",
                requestBody: {
                    "referral_code": agentId
                }
            })

            if (engagementIncome.status === 200) {
                const groupData = engagementIncome.data.reduce((acc, item) => {
                    if (!acc[item.subscription]) {
                        acc[item.subscription] = { totalAmount: 0 }
                    }
                    acc[item.subscription].totalAmount += item.amount
                    return acc
                }, {})

                console.log("check", groupData)
                setAgentIncome(groupData)
                setShowModal(true)
            } else {
                dispatch({ type: 'SET_SHOW_ERROR', payload: true })
                dispatch({ type: 'SET_ERROR', payload: 'Error fetching income details' })
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
                console.log("Error fetching income details", engagementIncome)
            }
        } catch (error) {
            dispatch({ type: 'SET_SHOW_ERROR', payload: true })
            dispatch({ type: 'SET_ERROR', payload: 'Error fetching income details' })
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError })
            console.log("Error fetching income details:", error)
        }
    }

    const userColumns = [
        {
            field: 'agent_id',
            headerName: "Referral Code",
            headerAlign: 'center',
            flex: 1,
            align: 'center',

        },
        {
            field: 'no_of_clients',
            headerName: "No. of Clients Managed",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
        },
        {
            field: 'brokerage',
            headerName: "Brokerage",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? Number(params).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0
            }
        },
        {
            field: 'income',
            headerName: "Other income generated",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <span>{params.value != null ? Number(params.value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}</span>
                    <IconButton
                        onClick={() => handleIncomeApi(params.row.agent_id)}
                    >
                        {params.value && <InfoIcon style={{ fontSize: '20px', color: '#00acfe' }} />}
                    </IconButton>
                </div>
            )
        },
        {
            field: 'total_revenue',
            headerName: "Total Revenue Generated",
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            valueFormatter: (params) => {
                return params != null ? params.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0
            }
        }
    ]

    const updatedAgentList = agentsList.map((agent) => ({
        ...agent,
        total_revenue: (parseFloat(agent.income) || 0) + (parseFloat(agent.brokerage) || 0)
    }))

    const handleDownloadCsv = () => {
        const header = ["Agent ID", "No.of Client Managed", "Brokerage", "Other Income", "Total Revenue"]
        const data = updatedAgentList.map(item => ({
            [header[0]]: item.agent_id,
            [header[1]]: item.no_of_clients,
            [header[2]]: item.brokerage != null ? Number(item.brokerage).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0,
            [header[3]]: item.income != null ? Number(item.income).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0,
            [header[4]]: item.total_revenue != null ? Number(item.total_revenue).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0,
        }))

        exportFromJSON({
            data,
            fileName: 'Agent_Engagement_List',
            exportType: exportFromJSON.types.csv
        })
    }

    return (
        <Grid container>
            <Grid item xs={12} style={{ display: 'flex', flexDirection: "column" }}>
                <form className={classes.lcFrmDtFld} onSubmit={handleSubmit}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <span>
                            <DatePicker
                                label="From"
                                format="DD-MM-YYYY"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ className: classes.input }}
                                className={classes.dtPckr}
                                value={fdate}
                                onChange={(newValue) => { handleFDate(newValue) }}
                                minDate={dayjs('2025-01-01')}
                            />
                            {error.from && (<Typography color="error" className={classes.errTxt}> {error.from} </Typography>)}
                        </span>

                        <br />

                        <span className={classes.dtPkrWpr}>
                            <DatePicker
                                label="To"
                                format="DD-MM-YYYY"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ className: classes.input }}
                                className={classes.dtPckr}
                                value={tdate}
                                onChange={(newValue) => { handleTDate(newValue) }}
                            />
                            {error.to && (<Typography color="error" className={classes.errTxt}> {error.to} </Typography>)}
                        </span>
                    </LocalizationProvider>

                    <Button type="submit" className={classes.sbtBtn}>Submit</Button>

                    <Grid container display="flex" justifyContent="flex-end" alignItems="center" sx={{ padding: '0 20px 0 0' }}>
                        {updatedAgentList.length > 0 && <Button className={classes.btnDwnCsv} onClick={handleDownloadCsv}>
                            Download CSV
                        </Button>}
                    </Grid>
                </form>
            </Grid>

            <Grid className={classes.horizantalTablayout} sx={{ marginTop: '10px' }}>
                <DataGrid
                
                    rows={updatedAgentList}
                    columns={userColumns}
                    getRowId={(row) => row.agent_id}
                    className={classes.customDataGrid}
                    style={{
                        '--DataGrid-containerBackground': '#131E2E',
                        '--DataGrid-rowBorderColor': '#000',
                        'border': 0,
                        width: '100% !important',
                    }}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 15 }
                        }
                    }}
                    pageSizeOptions={[10, 15, 25]}
                />
            </Grid>

            <Grid item xs={12}>
                {showModal && <IncomeForm showModal={showModal} setShowModal={setShowModal} agentIncome={agentIncome} />}
            </Grid>
        </Grid>
    )
}

export default withStyles(styles)(AgentsList)